var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ocean-ui-vlink",class:_vm.classes,style:(_vm.styles),attrs:{"to":_vm.to,"tag":_vm.tag,"replace":_vm.replace,"append":_vm.append}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }